<script setup>
import { cn } from "~/utils/cn";

defineProps({
  size: { type: String, default: "md", validator: (v) => ["sm", "md", "lg"].includes(v) },
  fit: { type: String, default: null, validator: (v) => ["grow", null].includes(v) },
  active: { type: Boolean, default: false },
});
</script>

<template>
  <button
    type="button"
    :class="
      cn(
        'cursor-pointer whitespace-nowrap border-b-2 border-transparent px-1 py-3 text-sm font-medium text-gray-500 hover:border-gray-200 data-[active=true]:border-blue-600 data-[active=true]:text-blue-600',
        $attrs.class ?? ''
      )
    "
    :data-active="active ?? $attrs['data-active'] ?? false"
  >
    <slot />
  </button>
</template>
